<template>
  <div class="bar">
    <div class="mobilebar">
      <div class="left">
        <img src="@/assets/mobileimg/lj-pub-logo-desktop.png"
             alt=""
             v-if="routerpath === '/mdestop'"
             class="desktop">
        <img src="@/assets/mobileimg/lj-pub-logo-market.png"
             alt=""
             v-else-if="routerpath === '/mmarket'"
             class="desktop">
        <img src="@/assets/mobileimg/lj-pub-logo.png"
             v-else
             alt="">
      </div>
      <div class="right">
        <div v-for="item in barlist"
            :class="[routerpath === item.path?'is_active':'']"
            :key="item.key">
          <span @click="goPath(item.path)">{{item.name}}</span>
        </div>
        <van-popover
          v-model="showPopover"
          trigger="click"
          :actions="moreList"
          placement="bottom-end"
          @select="onSelect"
        >
          <template #reference>
          <div @click="clickmore" :class="[routerpath === '/more'?'is_active':'']">更多</div>
          </template>
        </van-popover>
        <!-- <img src="@/assets/mobileimg/lj-wap-pub-nav-nor.png"
             alt=""> -->
      </div>
    </div>
    <!-- <van-popup v-model="show"
               position="right"
               :style="{ height: '100%' }">
      <div class="mobilebar">
        <div class="left">
          <img src="@/assets/mobileimg/lj-pub-logo.png"
               alt="">
        </div>
        <div class="right"
             @click="closepopup">
          <img src="@/assets/mobileimg/lj-wap-pub-nav-sel.png"
               alt="">
        </div>
      </div>
      <div v-for="item in barlist"
           :key="item.key">
        <van-cell :title="item.name"
                  value=" "
                  size="large"
                  @click="goPath(item.path)"
                  v-if="item.children.length===0">
        </van-cell>
        <van-collapse v-model="activeNames"
                      v-else>
          <van-collapse-item :title="item.name"
                             name="1"
                             value=" ">
            <van-cell :title="it.name"
                      size="large"
                      v-for="it in item.children"
                      @click="goPath(it.path)"
                      :key="it.key">
            </van-cell>
          </van-collapse-item>
        </van-collapse>
      </div>
    </van-popup> -->
    <router-view />
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Popup,
  Cell, CellGroup, Collapse, CollapseItem, Popover
} from 'vant'
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Popup)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Popover)
export default {
  name: 'bar',
  data () {
    return {
      show: false,
      activeNames: [1],
      routerpath: '',
      barlist: [
        {
          name: '首页',
          path: '/mindex',
          key: 'index',
          auth: true,
          children: []
        },
        {
          name: '乐家市场',
          path: '/mmarket',
          key: 'mmarket',
          auth: true,
          children: [

          ]
        }
        // {
        //   name: '乐家桌面',
        //   path: '/mdestop',
        //   key: 'mdestop',
        //   auth: true,
        //   children: [
        // {
        //   name: '乐家桌面',
        //   path: '/mdestop',
        //   key: 'mdestop',
        //   auth: true
        // },
        // {
        //   name: '乐家桌面管理后台',
        //   path: '/mhome',
        //   key: 'mhome',
        //   auth: true
        // }
        //   ]
        // }

        // {
        //   name: '关于我们',
        //   path: '/maboutus',
        //   key: 'about',
        //   auth: true,
        //   children: []
        // }
      ],
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [{ text: '选项一' }, { text: '选项二' }, { text: '选项三' }],
      moreList: [
        // {
        // name: '更多',
        // path: '/more',
        // key: 'more',
        // auth: true,
        // children: [
        {
          text: '乐家市场分享码',
          path: '/group-list',
          key: 'sharingcode',
          auth: true,
          children: []
        },
        // {
        //   text: '乐家桌面管理后台',
        //   path: '/mhome',
        //   key: 'mhome',
        //   auth: true,
        //   children: []
        // },
        {
          text: '乐家固件平台',
          path: '/ljfirmware',
          key: 'ljfirmware',
          auth: true,
          children: []
        }
        // ]
        // }
      ]
    }
  },
  components: {},
  // 钩子函数: 数据监听
  watch: {
  },
  created: function () {

  },
  mounted () {
    this.routerpath = location.pathname
  },
  methods: {
    showpopup () {
      this.show = true
    },
    clickmore () {
      this.routerpath = '/more'
    },
    onSelect (action) {
      console.log(action)
      if (action.path === '/mhome') {
        // location.href = 'http://admin.shengyyy.com'
        window.open('https://launcher.xuntu56.com/launcher/#/login')
      } else if (action.path === '/ljfirmware') {
        window.open('https://tvrom.lejiamk.com')
      } else {
        this.$router.push({ path: action.path })
      }
    },
    closepopup () {
      this.show = false
    },
    goPath (path) {
      // console.log(path)
      this.show = false
      this.routerpath = path
      if (path === '/mhome') {
        // location.href = 'http://admin.shengyyy.com'
        window.open('https://launcher.xuntu56.com/launcher/#/login')
      } else if (path === '/ljfirmware') {
        window.open('https://tvrom.lejiamk.com')
      } else {
        this.$router.push({ path: path })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.bar {
  //  font-family: Roboto, sans-serif;
  background: #ffffff;
  //   color: #333;
  margin: 0;
  display: block;
  font-family: MicrosoftYaHei-Bold;
  font-size: 16px;
  color: #333333;
  line-height: 24px;
  font-weight: 700;
}
.mobilebar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px 15px 12px;
  border-bottom: 1px solid rgba(234, 234, 234, 1);
  .left {
    img {
      width: 56px;
      height: 52px;
    }
    .desktop {
      width: 145px;
      height: 52px;
    }
  }
  .right {
    img {
      width: 20px;
      height: 20px;
    }
    div{
      display: inline-block;
      margin-right: 10px;

    }
    div:last-child{
      margin-right: 0;
    }
  }
}
/deep/ .van-popup--right {
  width: 100%;
}
/deep/ .van-cell--large {
  width: 100%;
  height: 40px;
  box-shadow: inset 0px -1px 0px 0px rgba(234, 234, 234, 1);
  padding: 0 20px;
  display: flex;
  align-items: center;
}
/deep/ .van-cell__value {
  // background: red;
  width: 20px;
  height: 20px;
  background: #2777f8;
  border-radius: 10px;
  flex: unset;
  span {
    position: relative;
    display: inline-block;
    font: normal normal normal 14px/1 vant-icon;
    font-size: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    margin-top: 3px;
    right: 2px;
    color: #fff;
  }
  span::before {
    content: "\F00A";
    display: inline-block;
  }
}
// van-cell van-cell--clickable van-collapse-item__title van-collapse-item__title--expanded
/deep/ .van-cell {
  height: 40px;
  padding: 0 20px;
  display: flex;
  align-items: center;
}
/deep/ .van-collapse-item__title {
  font-size: 15px;
  .van-cell__value {
    // background: red;
    width: 20px;
    height: 20px;
    background: #2777f8;
    border-radius: 10px;
    flex: unset;
    span {
      position: relative;
      display: inline-block;
      font: normal normal normal 14px/1 vant-icon;
      font-size: inherit;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
      margin-top: 9px;
      right: 2px;
      background: #fff;
      width: 14px;
      height: 2px;
    }
    span::before {
      content: "";
      display: inline-block;
    }
  }
}
/deep/ .van-icon-arrow {
  display: none;
}
/deep/ .van-cell__title {
  font-size: 15px;
}
.is_active{
  color:#2777f8;
}
</style>
<style lang="scss">
.van-popover__action {
  width:150px !important;
}
</style>



// WEBPACK FOOTER //
// src/mobileBar/index.vue